import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment.prod';
import { FunctionalityDto } from '@models/authorizations/functionality.entity';
import { GroupDto } from '@models/authorizations/group.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  private AuthorizationPath = {
    groupList: () => `/authorizations/list`,
    createGroup: () => `/authorizations/create`,
    modifyGroup: () => `/authorizations/modify`,
    removeGroup: () => `/authorizations/remove`,
    functionList: () => `/functionality/list`,
    createFunction: () => `/functionality/create`,
    modifyFunction: () => `/functionality/modify`,
    removeFunction: () => `/functionality/remove`,
    assignToGroup: () => `/authorizations/assign`,
  };

  constructor(private http: HttpClient) {}

  public groupList(): Observable<GroupDto[]> {
    return this.http.get<GroupDto[]>(
      environment.host + this.AuthorizationPath.groupList(),
    );
  }

  public modifyGroup(groups: GroupDto[]) {
    return this.http.post<GroupDto[]>(
      environment.host + this.AuthorizationPath.modifyGroup(),
      groups,
    );
  }

  public removeGroup(groups: GroupDto[]) {
    return this.http.post<GroupDto[]>(
      environment.host + this.AuthorizationPath.removeGroup(),
      groups,
    );
  }

  public functionalityList(): Observable<FunctionalityDto[]> {
    return this.http.get<FunctionalityDto[]>(
      environment.host + this.AuthorizationPath.functionList(),
    );
  }

  public modifyFunctionality(groups: FunctionalityDto[]) {
    return this.http.post<FunctionalityDto[]>(
      environment.host + this.AuthorizationPath.modifyFunction(),
      groups,
    );
  }

  public removeFunctionality(groups: FunctionalityDto[]) {
    return this.http.post<FunctionalityDto[]>(
      environment.host + this.AuthorizationPath.removeFunction(),
      groups,
    );
  }
}
